import * as Sentry from '@sentry/react'
import { SENTRY_SEVERITY } from 'src/service/utils/sentry'
import { cmdTypeLabel, WATCH_CMD_TYPES } from 'src/service/utils/sentry/api'
import { CMD_TYPES } from 'src/types/cmdtype'

type FlowPhase = 'request' | 'response'

type FlowBreadcrumbData = {
  cmdType?: number
  errCode?: number
  errMsg?: string
}

function flowLabel(cmdType: number): string {
  for (const [name, value] of Object.entries(CMD_TYPES)) {
    if (value === cmdType) return name
  }
  return String(cmdType)
}

export function addApiBreadcrumb(phase: FlowPhase, data: FlowBreadcrumbData) {
  const cmdType = data?.cmdType
  if (!cmdType || !WATCH_CMD_TYPES.has(cmdType)) return

  Sentry.addBreadcrumb({
    category: 'flow',
    message: `${flowLabel(cmdType)}[${phase}]`,
    level: phase === 'response' ? SENTRY_SEVERITY.Warning : SENTRY_SEVERITY.Info,
    data: {
      cmdType: cmdTypeLabel(cmdType),
      path: window.location.pathname,
      phase,
      ...data,
    },
  })
}
